import React from "react";
import { createRoot } from "react-dom/client"; // Updated import for React 18

const Notification = ({ message }) => {
	return (
		<div className="notification">
			<p>{message}</p>
		</div>
	);
};

const showNotification = (message, duration = 3000) => {
	const notificationRoot = document.createElement("div");
	document.body.appendChild(notificationRoot);

	// New API usage for React 18
	const root = createRoot(notificationRoot);
	root.render(<Notification message={message} />);

	// Automatically remove the notification after `duration`
	setTimeout(() => {
		root.unmount();
		document.body.removeChild(notificationRoot);
	}, duration);
};

export default showNotification;
